

import React from 'react';

const ToggleInput = (props: { className: string, onClick?: Function }) => {
  const { className, onClick } = props;

  const handleOnClick = (e: any) => {

    if (onClick) onClick(true);
  }

  return (

        <svg className={className} onClick={handleOnClick} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <g id="icon">
            <g id="container-padding">
            <path id="Vector" d="M18 2V2.00999M18 17.99V18M18 13.9925V14.0025M18 9.995V10.005M18 5.9975V6.0075M2 2V2.00999M2 17.99V18M2 13.9925V14.0025M2 9.995V10.005M2 5.9975V6.0075M6.005 17.995H5.995M10.005 17.995H9.995M14.005 17.995H13.995M6.005 2.005L5.995 2.005M10.005 2.005L9.995 2.005M14.005 2.005L13.995 2.005M7 13.9925H13C13.5523 13.9925 14 13.5451 14 12.9931V6.99688C14 6.44494 13.5523 5.9975 13 5.9975H7C6.44772 5.9975 6 6.44494 6 6.99688V12.9931C6 13.5451 6.44772 13.9925 7 13.9925Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
        </g>
</svg>
  );
};
export default ToggleInput;
